import { render, staticRenderFns } from "./UnifiedLeaveList.vue?vue&type=template&id=d200996a&scoped=true"
import script from "./UnifiedLeaveList.vue?vue&type=script&lang=js"
export * from "./UnifiedLeaveList.vue?vue&type=script&lang=js"
import style0 from "./UnifiedLeaveList.vue?vue&type=style&index=0&id=d200996a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d200996a",
  null
  
)

export default component.exports